import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import _ from "lodash";
import styled from "styled-components";
import axios from "axios";

import BookingsApi from "../../api/bookings-api";
import DormsApi from "../../api/dormitories-api";
import EventsApi from "../../api/events-api";
import LabsApi from "../../api/labs-api";
import UniversityApi from "../../api/university-api";
import { EVENT_TYPES_OPTIONS } from "../../constants/config";
import { useStorageListener } from "../../hooks/useStorage";
import moment from "moment-timezone";
import { Button, Container } from "../ui-kit/styled-templates";
import { getBookingsMatrixMap, getBookingsUnisStats, getDatesArr } from "../pages/admin/admin-stats-app";
import { Control } from "../ui-kit/control";
import AmbStatsPanel from "../ambassadors/panels/AmbStatsPanel";
import * as XLSX from "xlsx";
import Sidebar from "arui-feather/sidebar";

const renderRow = (items) => {
    console.log("renderRow: items = ", items);
    return (
        <BoxesRow>
            {items.map((a, i) => {
                let cont = (
                    <StatBox key={a.label} clickable={a.onClick != undefined}>
                        <StatLabel>{a.label}</StatLabel>
                        <StatValue>{a.value}</StatValue>
                    </StatBox>
                );
                if (a.link != undefined) {
                    return (
                        <Link key={a.label} to={a.link}>
                            {cont}
                        </Link>
                    );
                } else if (a.onClick != undefined) {
                    return (
                        <div key={a.label} onClick={a.onClick} style={{ cursor: 'pointer' }}>
                            {cont}
                        </div>
                    );
                } else {
                    return cont;
                }
            })}
        </BoxesRow>
    );
};

export default function UniversityDashboard(props) {
    const { t } = useTranslation();

    const userId = useStorageListener((store) => props.userId || store.user.id || "");
    const university = useStorageListener(`universities`, {});
    let myUni = _.values(university).filter((x) => x?.userId == userId)[0];

    const [bookings, setBookings] = useState([]);
    const [eventBookings, setEventBookings] = useState([]);
    const [universityStudents, setUniversityStudents] = useState([]);
    const [studentsModalVisible, setStudentsModalVisible] = useState(false);

    const [unisMap, setUnisMap] = useState({});

    const [isLastMonth, setIsLastMonth] = useState(false);

    const dormitories = useStorageListener((state) => _.values(state?.dormitories));
    const events = useStorageListener((state) => _.values(state?.events));
    const labs = useStorageListener((state) => _.values(state?.labs));

    useEffect(UniversityApi.getAllUniversitiesData, []);
    useEffect(EventsApi.getEvents, []);
    useEffect(LabsApi.getLabs, []);
    useEffect(DormsApi.getAllDormitories, []);

    let myDorms = dormitories.filter((x) => x?.universityId == myUni?.id);
    let myEvents = events.filter((x) => x?.universityId == myUni?.id);
    let myLabs = labs.filter((x) => x?.universityId == myUni?.id);


    console.log("all dormitories = ", dormitories);
    console.log("all events = ", events);
    console.log("all labs = ", labs);
    console.log("myDorms = ", myDorms);
    console.log("myEvents = ", myEvents);
    console.log("myBookings = ", bookings);

    let eventsMap = events.reduce((mp, ev) => ({ ...mp, [ev.id]: ev }), {});

    const [range, setRange] = useState({
        from: +moment().add(-3, "months").startOf("month").startOf("day"),
        to: +moment().endOf("year").startOf("day")
    });

    const handleFromChange = (t) => {
        setRange((prevRange) => ({
            ...prevRange,
            from: t // Convert Date object to Unix timestamp
        }));
    };

    const handleToChange = (t) => {
        setRange((prevRange) => ({
            ...prevRange,
            to: t // Convert Date object to Unix timestamp
        }));
    };

    let myRooms = myDorms.reduce((rm, dorm) => rm.concat(_.values(dorm?.rooms || {})), []);
    console.log("myRooms = ", myRooms);
    console.log("myLabs = ", myLabs);
    let totalLivingRoomsNumber = myRooms
        .map((x) => x?.details.amount)
        .filter((x) => x != undefined)
        .map((x) => +x)
        .reduce((sm, x) => +sm + x, 0);

    useEffect(() => {
        console.log("ue: userId = ", userId);
        console.log("ue: myUni = ", myUni);
        if (userId == undefined || userId == "") {
            return;
        }
        BookingsApi.getMyBookings().then((arr) => {
            setBookings(arr);
        });
        EventsApi.getAllBookings().then((arr2) => {
            setEventBookings(arr2);
        });
        // Load university students
        if (myUni?.id) {
            axios.get(`/university-students?universityId=${myUni.id}`).then((response) => {
                setUniversityStudents(response.data || []);
            }).catch((error) => {
                console.error("Error loading university students:", error);
            });
        }
        // /universities/:universityId/bookings
    }, [userId, myUni]);

    if (myUni == undefined) {
        return <div>{t("6qr3yu400gs")}</div>;
    }

    const eventsTypesMap = events.reduce((mp, x) => ({ ...mp, [x.id]: x?.details?.type }), {});
    let userTypesMap = {};
    for (let i in eventBookings) {
        let evB = eventBookings[i];
        let evId = evB.eventId;
        let tp = eventsTypesMap[evId] || "cultural";
        if (userTypesMap[evB.userId] == undefined) {
            userTypesMap[evB.userId] = ["cultural"];
        }
        userTypesMap[evB.userId].push(tp);
    }
    console.log("userTypesMap = ", userTypesMap);
    let xBookings = JSON.parse(JSON.stringify(bookings));

    xBookings = xBookings.filter((x) => {
        let from = +moment(x?.dates?.from);
        let to = +moment(x?.dates?.to);
        return from >= +range.from && to <= +range.to;
    });

    for (let i in xBookings) {
        let uId = xBookings[i].userId;
        xBookings[i].evTypes = userTypesMap[uId] == undefined ? ["cultural"] : userTypesMap[uId];
    }

    let myEvBookings = eventBookings.filter((x) => x.universityId == myUni?.id);


    let xMyEvBookings = JSON.parse(JSON.stringify(myEvBookings));


    xMyEvBookings = xMyEvBookings.filter((x) => {
        return (+x.timestamp > +range.from && +x.timestamp < +range.to);
    });

    for (let i in xMyEvBookings) {
        let ev = eventsMap[xMyEvBookings[i].eventId];
        let tp = ev?.details?.type || "cultural";
        xMyEvBookings[i].evType = tp;
    }

    let minTimestamp = bookings.map((x) => +moment(x?.dates?.from)).reduce((mn, x) => (mn > +x ? +x : +mn), +new Date());
    let maxTimestamp = bookings.map((x) => +moment(x?.dates?.to)).reduce((mx, x) => (mx < +x ? +x : +mx), +new Date());
    if (isLastMonth == true) {
        minTimestamp = +moment().add(-1, "months").startOf("day");
    }
    let possibleDates = getDatesArr(minTimestamp, maxTimestamp);

    let unisStatsItems = getBookingsUnisStats(bookings);
    let datesMatrix = getBookingsMatrixMap(bookings);

    return (
        <Wrapper>
            <h1>{myUni?.details?.name}</h1>

            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ marginRight: "10px;" }}>
                    <Control.Date
                        value={range.from}
                        onChange={evt => {
                            console.log("Date: onChange: evt = ", evt);
                            handleFromChange(evt.target.value);
                        }}
                    />
                </div>
                <div>
                    <Control.Date
                        value={range.to}
                        onChange={evt => {
                            console.log("Date: onChange: evt = ", evt);
                            handleToChange(evt.target.value);
                        }}
                    />
                </div>
            </div>


            <h2>
                <Link to={`/dormitories`}>{t("k3o6g8dl8f")}</Link>
            </h2>


            <BoxesRow>
                {renderRow([
                    {
                        label: t("r4shohn1ckd"),
                        value: myDorms.length,
                        link: "/dormitories"
                    },
                    {
                        label: t("3tqhecoogwx"),
                        value: totalLivingRoomsNumber,
                        link: "/dormitories"
                    }
                ])}
            </BoxesRow>

            {/*<h3>*/}
            {/*    Заявки на бронирование проживания*/}
            {/*</h3>*/}

            {/*<div>*/}
            {/*    {EVENT_TYPES_OPTIONS.map((a, i) => {*/}
            {/*        let rBookings = xBookings.filter((x) => (x.evTypes || []).indexOf(a.value) > -1);*/}

            {/*        const totalBookingsCount = (rBookings || []).reduce((sm, x) => +sm + Math.min(+x.quantity, 100000), 0);*/}
            {/*        let individualBookings = rBookings.filter((x) => x?.author?.role == "user");*/}
            {/*        let groupBookings = rBookings.filter((x) => x?.author?.role == "uni-admin");*/}
            {/*        const individualBookingsCount = (individualBookings || []).reduce((sm, x) => +sm + Math.min(+x.quantity, 100000), 0);*/}
            {/*        const groupBookingsCount = (groupBookings || []).reduce((sm, x) => +sm + Math.min(+x.quantity, 100000), 0);*/}

            {/*        return (*/}
            {/*            <div key={i}>*/}
            {/*                /!*<h3>{a.trackLabel + ' '}</h3>*!/*/}
            {/*                <h3>{a.label + ' '}</h3>*/}
            {/*                {renderRow([*/}
            {/*                    {*/}
            {/*                        label: t("pi2auh3t51p"),*/}
            {/*                        value: rBookings.length*/}
            {/*                    },*/}
            {/*                    {*/}
            {/*                        label: t("qx1n3etlhb"),*/}
            {/*                        value: totalBookingsCount*/}
            {/*                    },*/}
            {/*                    {*/}
            {/*                        label: t("hurpn9bhape"),*/}
            {/*                        value: individualBookings.length*/}
            {/*                    },*/}
            {/*                    {*/}
            {/*                        label: t("wby3lpqrpma"),*/}
            {/*                        value: groupBookings.length*/}
            {/*                    },*/}
            {/*                    {*/}
            {/*                        label: t("lass9g3unuq"),*/}
            {/*                        value: individualBookingsCount*/}
            {/*                    }*/}
            {/*                ])}*/}
            {/*            </div>*/}
            {/*        );*/}
            {/*    })}*/}
            {/*</div>*/}

            <div>
                {[0].map((a, i) => {
                    let rBookings = xBookings;
                    // let rBookings = xBookings.filter((x) => (x.evTypes || []).indexOf(a.value) > -1);

                    const totalBookingsCount = (rBookings || []).reduce((sm, x) => +sm + Math.min(+x.quantity, 100000), 0);
                    let individualBookings = rBookings.filter((x) => x?.author?.role == "user");
                    let groupBookings = rBookings.filter((x) => x?.author?.role == "uni-admin");
                    const individualBookingsCount = (individualBookings || []).reduce((sm, x) => +sm + Math.min(+x.quantity, 100000), 0);
                    const groupBookingsCount = (groupBookings || []).reduce((sm, x) => +sm + Math.min(+x.quantity, 100000), 0);

                    return (
                        <div key={i}>
                            {/*<h3>{a.trackLabel + ' '}</h3>*/}
                            {/*<h3>{a.label + ' '}</h3>*/}
                            {renderRow([
                                {
                                    label: t("pi2auh3t51p"),
                                    value: rBookings.length
                                },
                                {
                                    label: t("qx1n3etlhb"),
                                    value: totalBookingsCount
                                },
                                {
                                    label: t("hurpn9bhape"),
                                    value: individualBookings.length
                                },
                                {
                                    label: t("wby3lpqrpma"),
                                    value: groupBookings.length
                                },
                                {
                                    label: t("lass9g3unuq"),
                                    value: individualBookingsCount
                                }
                            ])}
                        </div>
                    );
                })}
            </div>

            <div style={{ marginTop: 15, marginBottom: 15 }}>
                  <span
                      style={{ cursor: "pointer", textAlign: "center", textDecoration: "underline" }}
                      onClick={() => {
                          // Create a new workbook and a worksheet
                          const wb = XLSX.utils.book_new();
                          const ws = XLSX.utils.aoa_to_sheet([]);

                          // Adding headers to the worksheet
                          XLSX.utils.sheet_add_aoa(ws, [["Бронирования", "Подтвержденные", "Отклоненные", "Новые", "В обработке", "Отмененные", "Исполнено-Приехал", "Испонено-Не приехал"]]);

                          let books = xBookings;
                          let approvedBooks = books.filter((x) => x.status == "approved");
                          let rejectedBooks = books.filter((x) => x.status == "rejected");
                          let newBooks = books.filter((x) => x.status == "new");
                          let reviewBooks = books.filter((x) => x.status == "review");
                          let canceledBooks = books.filter((x) => x.status == "canceled");

                          let done_visitedBooks = books.filter((x) => x.status == "done_visited");
                          let done_not_visitedBooks = books.filter((x) => x.status == "done_not_visited");

                          // Adding each row of data to the worksheet
                          XLSX.utils.sheet_add_aoa(ws, [[books.length, approvedBooks.length, rejectedBooks.length, newBooks.length, reviewBooks.length, canceledBooks.length, done_visitedBooks.length, done_not_visitedBooks.length]], { origin: -1 });

                          // Adding the worksheet to the workbook
                          XLSX.utils.book_append_sheet(wb, ws, "Report");

                          // Generate a CSV file and trigger download
                          XLSX.writeFile(wb, "export.xlsx");
                      }}
                  >
                        создать отчет по размещениям
                    </span>
            </div>

            <h2>
                <Link to={`/events`}>{t("1u17tmu792c")}</Link>
            </h2>

            {renderRow(
                EVENT_TYPES_OPTIONS.map((a, i) => {
                    let xEvents = myEvents.filter((xx) => xx?.details?.type == a.value);
                    return {
                        label: a.label,
                        value: xEvents.length,
                        link: "/events"
                    };
                })
            )}

            <div>
                {EVENT_TYPES_OPTIONS.map((a, i) => {
                    let rBookings = xMyEvBookings.filter((x) => x.evType == a.value);

                    console.log("EVENT_TYPES_OPTIONS: EV: rBookings = ", rBookings);

                    const totalBookingsCount = (rBookings || []).reduce((sm, x) => +sm + Math.min(+x?.details?.quantity, 100000), 0);
                    let individualBookings = rBookings.filter((x) => x?.author?.role == "user");
                    let groupBookings = rBookings.filter((x) => x?.author?.role == "uni-admin");
                    const individualBookingsCount = (individualBookings || []).reduce((sm, x) => +sm + Math.min(+x?.details?.quantity, 100000), 0);
                    const groupBookingsCount = (groupBookings || []).reduce((sm, x) => +sm + Math.min(+x?.details?.quantity, 100000), 0);

                    return (
                        <div key={i}>
                            <h3>{a.label}</h3>
                            {renderRow([
                                {
                                    label: t("agls21kmw4v"),
                                    value: rBookings.length
                                },
                                {
                                    label: t("df0v9ofkenc"),
                                    value: totalBookingsCount
                                }
                                // {
                                //     label: "Индивидуальных заявок",
                                //     value: individualBookings.length
                                // },
                                // {
                                //     label: "Групповых заявок",
                                //     value: groupBookings.length
                                // }
                            ])}
                        </div>
                    );
                })}
            </div>


            <div style={{ marginTop: 15, marginBottom: 15 }}>
                <span className={"cursor-pointer"} style={{ cursor: "pointer", textDecoration: "underline" }}
                      onClick={() => {
                          const wb = XLSX.utils.book_new();
                          const ws = XLSX.utils.aoa_to_sheet([]);

                          // Adding headers to the worksheet
                          XLSX.utils.sheet_add_aoa(ws, [["Бронирования", "Подтвержденные", "Отклоненные", "Новые", "В обработке", "Отмененные", "Исполнено-Приехал", "Испонено-Не приехал"]]);

                          let books = xMyEvBookings;
                          let approvedBooks = books.filter((x) => x.status == "approved");
                          let rejectedBooks = books.filter((x) => x.status == "rejected");
                          let newBooks = books.filter((x) => x.status == "new");
                          let reviewBooks = books.filter((x) => x.status == "review");
                          let canceledBooks = books.filter((x) => x.status == "canceled");

                          let done_visitedBooks = books.filter((x) => x.status == "done_visited");
                          let done_not_visitedBooks = books.filter((x) => x.status == "done_not_visited");

                          // Adding each row of data to the worksheet
                          XLSX.utils.sheet_add_aoa(ws, [[books.length, approvedBooks.length, rejectedBooks.length, newBooks.length, reviewBooks.length, canceledBooks.length, done_visitedBooks.length, done_not_visitedBooks.length]], { origin: -1 });

                          // Adding the worksheet to the workbook
                          XLSX.utils.book_append_sheet(wb, ws, "Report");

                          // Generate a CSV file and trigger download
                          XLSX.writeFile(wb, "events_export.xlsx");
                      }}>
                    скачать отчет по событиям
                </span>
            </div>

            {/*<DormsSection>*/}
            {/*    {myEvents.map((a, i) => {*/}
            {/*        return (*/}
            {/*            <DormItem key={a.id}>*/}
            {/*                <Link to={`/events/${a?.id}`}>*/}
            {/*                    <DormName>*/}
            {/*                        {a?.details?.name}*/}
            {/*                    </DormName>*/}
            {/*                </Link>*/}
            {/*            </DormItem>*/}
            {/*        );*/}
            {/*    })}*/}
            {/*</DormsSection>*/}

            <h2>{t("o2cxqax7db")}</h2>

            <BoxesRow>
                {renderRow([
                    {
                        label: t("sidlxnwdfla"),
                        value: myLabs.length,
                        labs: "/labs"
                    }
                ])}
            </BoxesRow>

            <h2>Студенты университета</h2>

            <BoxesRow>
                {renderRow([
                    {
                        label: "Количество студентов",
                        value: universityStudents.length,
                        onClick: () => setStudentsModalVisible(true)
                    }
                ])}
            </BoxesRow>

            <h2>
                Тепловая карта
            </h2>

            <div>
                <ul>
                    <li style={{ fontWeight: (isLastMonth == true) ? "bold" : "normal", cursor: "pointer" }}
                        onClick={() => {
                            setIsLastMonth(true);
                        }}>
                        за последний месяц
                    </li>
                    <li style={{ fontWeight: (isLastMonth == false) ? "bold" : "normal", cursor: "pointer" }}
                        onClick={() => {
                            setIsLastMonth(false);
                        }}>
                        за все время
                    </li>
                </ul>
            </div>

            <TableWrapper style={{ marginTop: 50, marginBottom: 40 }}>
                <MyTable>
                    <thead>
                    <tr>
                        {possibleDates.map((x, i) => {
                            return <DatesSpanHead key={x}>{moment(x).format("DD.MM")}</DatesSpanHead>;
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {unisStatsItems.map((a, i) => {
                        let uniId = a.name;
                        return (
                            <MyTr key={i}>
                                {possibleDates.map((x, j) => {
                                    let xKey = `${uniId}_${x}`;
                                    let mxData = datesMatrix[xKey];
                                    return (
                                        <MyTd
                                            key={x}
                                            color={mxData?.color}
                                            onClick={() => {
                                                let msg = `${x} - ${unisMap[uniId]} - ${mxData?.value == undefined ? "0" : mxData?.value}`;
                                                window.alert(msg);
                                            }}
                                        >
                                            {mxData?.value}
                                        </MyTd>
                                    );
                                })}
                            </MyTr>
                        );
                    })}
                    </tbody>
                </MyTable>
            </TableWrapper>

            <div>

                <h2 style={{ marginBottom: 20 }}>
                    Статистика амбассадора
                </h2>

                {myUni?.id == undefined ? null :
                    <AmbStatsPanel
                        universityId={myUni?.id}
                    />
                }


                {/*<StatsLi>*/}
                {/*    <LiLabel>*/}
                {/*        {`Количество пользователей, зарегистрированных на Платформе по реферальной ссылке: `}*/}
                {/*    </LiLabel>*/}
                {/*    <LiVal>*/}
                {/*        {3}*/}
                {/*    </LiVal>*/}

                {/*</StatsLi>*/}
                {/*<StatsLi>*/}
                {/*    <LiLabel>*/}
                {/*        {`Перечень мероприятий, в которых Амбассадор принял участие с использованием средств Платформы:`}*/}
                {/*    </LiLabel>*/}
                {/*    <div style={{ paddingLeft: 20 }}>*/}
                {/*        <li>*/}
                {/*            {`Мероприятие 1`}*/}
                {/*        </li>*/}
                {/*        <li>*/}
                {/*            {`Мероприятие 2`}*/}
                {/*        </li>*/}
                {/*    </div>*/}
                {/*</StatsLi>*/}
                {/*<StatsLi>*/}
                {/*    <LiLabel>*/}
                {/*        {`Количество исполненных бронирований путешественников, зарегистрированных по реферальной ссылке, в статусе «Исполнено: приехал»: `}*/}
                {/*    </LiLabel>*/}
                {/*    <LiVal>*/}
                {/*        {12}*/}
                {/*    </LiVal>*/}
                {/*</StatsLi>*/}

                {/*<div style={{ marginBottom: 30 }}>*/}
                {/*    /!*<h2>*!/*/}
                {/*    /!*    Отчет*!/*/}
                {/*    /!*</h2>*!/*/}
                {/*    <div>*/}
                {/*        <Control.DateRange name="dateRange"*/}
                {/*                           value={{*/}
                {/*                               from: moment().add(-1, "months").startOf("day"),*/}
                {/*                               to: moment().add(-1, "months").endOf("day")*/}
                {/*                           }}*/}
                {/*                           label={""} placeholder={""} />*/}
                {/*    </div>*/}
                {/*    <div>*/}
                {/*        <Button>*/}
                {/*            сформировать отчет*/}
                {/*        </Button>*/}
                {/*    </div>*/}

                {/*</div>*/}

            </div>

            {/*<DormsSection>*/}
            {/*    {myLabs.map((a, i) => {*/}
            {/*        return (*/}
            {/*            <DormItem key={a.id}>*/}
            {/*                <Link to={`/labs/${a?.id}`}>*/}
            {/*                    <DormName>*/}
            {/*                        {a?.details?.name}*/}
            {/*                    </DormName>*/}
            {/*                </Link>*/}
            {/*            </DormItem>*/}
            {/*        );*/}
            {/*    })}*/}
            {/*</DormsSection>*/}

            <Sidebar visible={studentsModalVisible} onCloserClick={() => setStudentsModalVisible(false)}>
                <ModalContent>
                    <h2>Студенты университета ({universityStudents.length})</h2>

                    <ExportButton onClick={() => {
                        // Export to CSV
                        const wb = XLSX.utils.book_new();
                        const wsData = [
                            ["№", "ФИО", "Email"]
                        ];

                        universityStudents.forEach((student, index) => {
                            wsData.push([
                                index + 1,
                                student.name || "",
                                student.email || ""
                            ]);
                        });

                        const ws = XLSX.utils.aoa_to_sheet(wsData);
                        XLSX.utils.book_append_sheet(wb, ws, "Students");
                        XLSX.writeFile(wb, `students_${myUni?.details?.shortName || 'university'}_${new Date().toISOString().split('T')[0]}.xlsx`);
                    }}>
                        Выгрузить список в XLS
                    </ExportButton>

                    <StudentsTable>
                        <thead>
                            <tr>
                                <th>№</th>
                                <th>ФИО</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {universityStudents.map((student, index) => (
                                <tr key={student.id || index}>
                                    <td>{index + 1}</td>
                                    <td>{student.name || "-"}</td>
                                    <td>{student.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </StudentsTable>
                </ModalContent>
            </Sidebar>
        </Wrapper>
    );
}


const LiLabel = styled.div`
  opacity: 0.7;
  font-size: 14px;
`;

const LiVal = styled.div`
  font-weight: bold;
  font-size: 18px;
`;

const StatsLi = styled.div`
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  background: white;
`;


const DormsSection = styled.div``;

const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
`;

const MyTable = styled.table`
  border-collapse: collapse;
  border: 1px solid lightgrey;
`;

const MyTr = styled.tr`
  :hover {
    background: lightgoldenrodyellow;
  }
`;

const MyTd = styled.td`
  border: 1px solid lightgrey;
  text-align: center;
  background: ${(props) => (props.color == undefined ? "white" : props.color)};
  height: 120px;
`;

const DatesSpanHead = styled.th`
  text-align: center;
  white-space: nowrap;
  font-size: 10px;
  border: 1px solid lightgrey;
`;

const UniRow = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  :hover {
    background: whitesmoke;
  }
`;

const BoxesRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  @media (max-width: 1020px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (max-width: 820px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 720px) {
    grid-template-columns: 1fr 1fr;
  }
  margin-left: -2px;
  margin-bottom: 10px;
`;

const StatBox = styled.div`
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  background: white;
  margin: 7px;
  min-width: 220px;
  transition: transform 0.2s, box-shadow 0.2s;

  ${props => props.clickable && `
    cursor: pointer;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  `}
`;

const StatLabel = styled.div`
  font-size: 14px;
  opacity: 0.5;
  font-weight: bold;
  height: 34px;
`;

const StatValue = styled.div`
  font-size: 42px;
  font-weight: bold;
  line-height: 64px;
`;

const DormName = styled.div`
  font-size: 18px;
  font-weight: bold;
`;

const DormItem = styled.div`
  padding: 10px;
  border: 1px solid grey;
  margin-bottom: 10px;
  border-radius: 4px;
  cursor: pointer;
  background: white;
  opacity: 0.8;

  :hover {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  text-align: left;
  width: 100%;
`;

const ModalContent = styled.div`
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;

  h2 {
    margin-bottom: 20px;
  }
`;

const ExportButton = styled.button`
  background: #02bf89;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background 0.2s;

  &:hover {
    background: #028a66;
  }
`;

const StudentsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  thead {
    background: #f5f5f5;

    th {
      padding: 12px 16px;
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      color: #333;
      border-bottom: 2px solid #e0e0e0;
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #f0f0f0;

      &:hover {
        background: #f9f9f9;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    td {
      padding: 12px 16px;
      font-size: 14px;
      color: #555;
    }
  }
`;
